import React, { useMemo, FC } from 'react';
import { Container } from '@goldbely/explore-component-library';

import { LazyImgix } from 'src/explore/elements/LazyImgix';
import { ICollection, IMerchant } from 'src/prize/types/shoppe';

import styles from './index.module.sass';

interface IImageProps {
  collection?: ICollection;
  merchant: IMerchant;
}

export const Image: FC<IImageProps> = ({
  collection,
  merchant: { bannerImageUrl, name, prizeFilePath },
}) => {
  const height = useMemo(() => {
    if ( prizeFilePath === 'hog_island_oyster_co' ) {
      return 214;
    }
    return 300;
  }, [ prizeFilePath ]);

  return bannerImageUrl || collection?.mainImageUrl ? (
    <Container className={styles.container} unpadded>
      <LazyImgix
        alt={name}
        className={styles.image}
        height={height}
        sizes="100vw"
        src={collection?.mainImageUrl ?? bannerImageUrl}
        width={1500}
      />
    </Container>
  ) : null;
};
